/**
 * Instructions
 *  - Renseigner les traductions par Module
 *  - Lorsque l'on rajoute une traduction, la rajouter également sur les autres fichiers de traductions (meme non traduite)
 */
export default {
	404: {
		not_found: 'Página no encontrada',
		go_home: 'Volver a la página de inicio'
	},
	general: {
		save: 'Guardar',
		valid: 'Validar',
		confirm: 'Confirmar',
		cancel: 'Cancelar',
		yes: 'Sí',
		no: 'No',
		monday: 'Lun.',
		tuesday: 'Mar.',
		wednesday: 'Mie.',
		thursday: 'Jue.',
		friday: 'Vie.',
		saturday: 'Sáb.',
		sunday: 'Dom.',
		add: 'Añadir',
		edit: 'Modificar',
		deploy: 'Implementar',
		close: 'Cerrar',
		logout_confirm: '¿Está seguro de querer cerrar sesión?',
		loading: 'Cargando...',
		warning: 'Cuidado',
		information: 'Información',
		delete: 'Supprimer',
		laddition: 'L\'Addition',
		i_get_it: 'Comprendo',
		help: 'Ayuda',
		contact: 'Contacto',
		documentation: 'Documentation',
		error: 'Se ha producido un error',
		back: 'Atrás',
		refresh_data: 'Actualizar los datos del socio',
		copy: 'Copiar'
	},
	dashboard: {
		dashboard: 'Tablero',
		export: 'Mis exportaciones',
		infos: 'Mis datos',
		partners: 'Mis socios',
		partner_export: 'Exportaciones de productos (tests)',
		menu: 'Menú digital'
	},
	info: {
		title: 'Datos',
		description: 'Descripción',
		short_description: 'Descripción corta',
		about: 'Presentación',
		changements_success: 'Sus cambios se han realizado',
		remaning_caracters: 'Caracteres restantes',
		picture: {
			menu: 'Menú digital',
			title: 'Imágenes',
			subtitle: 'Puedes añadir un archivo PDF o hasta 8 imágenes (max 20mo)',
			new_picture: 'Añadir una imagen',
			drag_drop_image: 'Arrastrar / Subir imagen',
			or: 'O',
			import: 'Importar',
			name: 'Nombre de la imagen',
			description: 'Descripción',
			confirm_delete: '¿Está seguro de querer eliminar esta imagen?',
			picture_porn: 'Atención, la imagen que desea añadir tiene un contenido inapropiado. Por favor, inténtelo de nuevo',
			nsfw_check: 'Comprobando su imagen',
			bad_extension: 'Los ficheros de tipo %{extension} no están permitidos',
			too_heavy: 'El fichero es demasiado grande',
			max_size: 'Tamaño máximo:'
		},
		address: {
			address: 'Dirección',
			number: 'N°',
			street: 'Nombre de la vía',
			city: 'Localidad',
			zip_code: 'Código postal',
			name: 'Nombre comercial',
			state: 'Provincia',
			country: 'País',
			custom_information: 'Información complementaria',
			longitude: 'Longitud',
			latitude: 'Latitud',
			locate_button: {
				init: 'Localizar automáticamente en el mapa',
				progress: 'Localización en curso...',
				fail: 'Fallo: no se han encontrado coincidencias',
				success: 'Su establecimiento ha sido localizado correctamente'
			},
			location_missing_fields: 'Debe introducir la dirección completa para iniciar la localización automática (Número y provincia son opcionales)\n',
			location_failed: 'Su establecimiento no ha sido localizado, por favor, compruebe la dirección. También puede mover el puntero de forma manual.',
			choose_location: 'Por favor, seleccione una dirección'
		},
		dates: {
			name: 'Nombre',
			open_time: 'Franjas horarias',
			start_date: 'Fecha de inicio',
			end_date: 'Fecha de fin',
			all_day: 'Todo el día',
			start: 'Inicio',
			end: 'Fin',
			days: 'Días',
			reserv_dates: 'Horarios de apertura',
			noon: 'Mediodía',
			evening: 'Noche',
			close_period: 'Periodo(s) de cierre',
			add_closing_date: 'Añadir una fecha de cierre',
			error_double_closing_date: 'Ya ha guardado este período de cierre',
			confirm_delete: '¿Está seguro de que quiere eliminar este período de cierre ?'
		}
	},
	menuOnline: {
		loadQrcode: 'Descargar Qrcode',
		goto: 'Ver'
	},
	binding: {
		button: 'Asociar',
		button_label_price: 'categorías de precio',
		button_label_payment: 'pagos',
		button_label_table: 'salas',
		title: 'Asociaciones',
		select_payment_type: 'Método de pago',
		select_floor: 'Sala',
		select_price_category: 'Categoría de precio (opcional)',
		none: '- Seleccionar -',
		default: 'Por defecto',
		help: 'En la aplicación y en el panel de informes, todos los pedidos grabados mediante el partenario se asociarán automáticamente a:',
		empty_payment_type: 'Ningún método de pago',
		empty_floor: 'Ninguna sala',
		empty_price_category: 'Ninguna categoría de precio',
		empty_general: 'Ningún elemento',
		customer_account: 'Cuenta de cliente'
	},
	product_quantity: {
		button: 'Modificar el umbral (Existencias)',
		title: 'Modificación del umbral de productos (existencias)',
		help: 'Permite desactivar automáticamente en el Click & Collect los productos cuyo numero sea inferior a esta cantidad. Los ajustes se realizan automáticamente a lo largo del servicio, en función de las existencias en el iPad.',
		help_2: 'Los ajustes se realizan automáticamente durante todo el servicio, en función del stock del iPad.',
		input: 'Umbral'
	},
	place_send: {
		button: 'Puntos de fabricación',
		title: 'Vinculación de los puntos de fabricación',
		info: 'En algunas configuraciones, cuando recibe un pedido de su socio, los productos no se imprimen porque están vinculados a una sala o a un punto de fabricación sin impresora. Por lo tanto, puede configurar vinculaciones para que un producto pedido por su socio se imprima en su lugar en el punto de envío asociado. Tenga en cuenta que esta configuración es específica de cada socio.',
		info_floor: 'A continuación puede definir la asignación de las salas hacia otro punto de fabricación para los pedidos procedentes de este socio.',
		empty: 'Ningún punto de envío configurado',
		printer: 'impresora',
		printers: 'impresoras',
		removed: 'eliminado',
		reset_confirm: 'Cambiar el modo de asociación restablecerá su configuración actual para este socio. ¿Está seguro de que desea realizar esta acción?',
		switch_place_send: 'Vinculación por punto de fabricación',
		switch_floor: 'Vinculación por sala',
		place_send: 'Punto de fabricación',
		floor: 'Sala'
	},
	partner_tax_rate: {
		button: 'Impuestos por producto',
		title: 'Impuestos por tipo de producto',
		help: 'Puede aplicar tipos de impuesto a algunos tipos de productos. Si no se indica, se utilizará el valor por defecto. Tenga en cuenta que estos tipos son específicos de cada socio',
		switch_default: 'Por defecto',
		switch_custom: 'Personalizado'
	},
	upload: {
		fail: 'Se ha producido un error al subir su imagen',
		error_code: {
			LIMIT_FILE_SIZE: 'El fichero que intenta cargar es demasiado grande'
		}
	},
	maintenance: {
		partners: {
			title: 'Mantenimiento en curso',
			description:
				'La gestión de los socios no está disponible temporalmente. Sus configuraciones se conservan, podrán modificarse de nuevo en breve.',
		},
	},
	partner: {
		variable: {
			sendOutletOnClosedOrders: 'Enviar la salida en los pedidos cerrados',
		},
		title: 'Socios',
		active: 'Activo',
		inactive: 'Inactivo',
		tooltip_partner_info: 'ID de socio y token',
		tooltip_partner_edit: 'Configurar el socio',
		tooltip_partner_help: 'Necessita ayuda ?',
		token_id_customer_undefined: 'Indisponible',
		infoUndefined: 'Non définie',
		put_active: 'Activar',
		search: 'Encuentra un socio...',
		link_espace_client: 'Dashboard',
		soon: '¿Mis futuros socios?',
		configuration: 'Configurar',
		configuration_in_progress: 'En configuración',
		continue_configuration: 'Continuar la configuración',
		click_to_continue: 'Haga clic para continuar',
		begin_configuration: 'Iniciar configuración',
		delete: {
			menu_binding: 'Eliminar la conexión',
			menu_config: 'Eliminar la configuración',
			title_binding: '¿Eliminar la conexión %{partner}?',
			title_config: '¿Eliminar la configuración de %{partner}?',
			config_intro:
				'Se eliminará la configuración en curso de %{partner}. Podrá reiniciarla desde el principio cuando quiera.',
			binding_intro:
				"Está a punto de eliminar definitivamente la conexión entre %{partner} y l'Addition.",
			effect_exchanges:
				'Los intercambios de datos con %{partner} se detendrán inmediatamente.',
			effect_settings:
				'Los identificadores, vinculaciones y parámetros de este socio se perderán definitivamente.',
			effect_reconfigure:
				'Para volver a utilizar este socio, habrá que rehacer toda la configuración.',
			acknowledge:
				'Entiendo que esta acción es irreversible e interrumpe el servicio.',
			type_to_confirm: 'Para confirmar, escriba el nombre del socio:',
		},
		one_click_activate: 'Activar con 1 clic',
		more_info: 'Más información',
		unlock: 'Desbloquear',
		call_partner_support: 'Póngase en contacto con su socio o con el servicio de asistencia de L\'Addition para obtener más información',
		onboarding_unavailable: 'Configuración no disponible',
		onboarding_unavailable_info:
			"La configuración de este socio no está disponible temporalmente. Vuelva a intentarlo más tarde o póngase en contacto con el soporte de l'Addition.",
		config_error: {
			title: 'Se ha producido un error',
			partner_config_missing: 'Este socio no está gestionado',
			auth_linking: 'Problema de vinculación de la pareja <> Adición',
			init_partner: 'Problema de inicialización del socio'
		},
		configuration_connector: {
			wait_title: 'Su petición ha sido tenida en cuenta.',
			wait_label: 'Después de firmar el presupuesto, vuelva aquí para configurar el conector.',
			wait_label_manual_onboarding: 'Tras firmar el presupuesto, nuestros equipos configurarán su conector',
			payment_method: 'Elige un método de pago para empezar a activar el conector',
			pay_cb: 'Pago CB: %{price}',
			need_contact: 'Para ser contactado por nuestros equipos',
			redirect: 'Será redirigido a la interfaz de pago'
		},
		label_lead_partner: '¿Aún no tiene %{partner} cuenta?',
		prospect_lead: '¿Le gustaría que le llamara el departamento de ventas del socio?',
		lead_partner_notif_ok: 'El servicio %{partner} ha sido notificado. Nos pondremos en contacto con usted lo antes posible',
		lead_partner_notif_ko: 'Se ha producido un error. Por favor, inténtelo de nuevo, o póngase en contacto con %{partner} directamente',
		locked_connector_info:
			"Conector de pago, contacte con su comercial de l'Addition para conocer las condiciones",
		connector_confirm: '¿Desea que informemos al departamento de ventas de su interés por este conector?  Le llamaremos lo antes posible',
		connector_confirm_ok: 'Se ha avisado al departamento de ventas. Nos pondremos en contacto con usted lo antes posible',
		connector_confirm_ko: 'No se ha podido avisar al departamento de ventas. Por favor, inténtelo de nuevo o póngase en contacto con ellos directamente',
		deliveroo_laddition_id: 'Su identificador de establecimiento (a indicar en el Hub Deliveroo antes de pasar al siguiente paso)',
		deliveroo_brand_id: 'Introduzca el identificador de marca (o Brand ID) proporcionado por Deliveroo',
		deliveroo_export: {
			1: '1. Desde la página de integraciones, haga clic en «Verifique el estado del menú»',
			2: '2. A continuación, haga clic en «Conecte sus pedidos»',
			3: '3. ¡La conexión ha finalizado! Si su caja está conectada a internet, ¡los pedidos se sincronizarán!',
			title: 'Diríjase a su Hub Deliveroo para finalizar la conexión:'
		},
		rushour_laddition_id: 'Su identificador de establecimiento (a indicar en la página Rushour antes de pasar al siguiente paso)',
		checkMinCharLength: {
			title: 'El nombre de los siguientes elementos de su menú supera el límite de caracteres permitido por su socio (entre %{min} y %{max} caracteres):',
			change_product: 'Para cambiar un producto, modifique el nombre en el formulario de exportación',
			change_supp: 'Para cambiar los suplementos, diríjase a la ventana de modificación de suplementos (botón "Modificar los suplementos") ',
			product: 'Producto',
			cat_supp: 'Categoría de suplemento',
			supp: 'Suplemento'
		},
		select_children: {
			title: 'Seleccione los establecimientos',
			select_all: 'Seleccionar / deseleccionar todo',
			no_set: 'no configurado'
		},
		reminder: 'Recordatorio',
		enter_key_at_partner: 'Comunique la clave al socio',
		enter_token_at_partner: 'Ingrese la clave en la interfaz del socio',
		waiting_for_partner: '¿La clave está registrada en la interfaz del socio?',
		active_link_ipad: 'Activar el enlace en la aplicación',
		link_with_partner_missing: 'No se pudo confirmar el enlace con el socio. Compruebe que la clave se haya registrado en la interfaz del socio o póngase en contacto con el soporte del socio.',
		link_with_partner_ok: 'Se ha confirmado el vínculo con el socio',
		check_overpaid: 'Asegúrese de que la opción "Convertir los pagos en exceso en propinas" de su aplicación está activada',
		update_nuc: 'Necesita actualizar su servidor la Adición',
		connexion_with_partner_missing: 'No se pudo confirmar la conexión con el socio. Compruebe que ha activado la conexión con el socio en la aplicación L’Addition, y que su iPad está encendido y la aplicación abierta',
		using_ipad: 'Parece que estás utilizando un iPad para completar el enlace con la aplicación Addition. La prueba de conectividad debe activarse desde otro dispositivo (PC u otra tableta) para confirmar el enlace. Si tienes más de un iPad, puedes activar la prueba desde uno de ellos.',
		generate_token: 'Haga clic aquí para generar la clave',
		copy_token: 'Copie la clave',
		token_copied: 'Clave copiada',
		copy: 'Haga clic para copiar',
		copied: '¡Copiado!',
		check_link_partner_to_customer: 'Compruebe la conexión',
		check_connexion_with_partner: 'Compruebe la conexión con el socio',
		check_connexion: 'Verifica la conexión',
		partner_ok: 'La conexión con el socio se ha configurado correctamente',
		ladditionMenu_accessAdminMenu_missing: 'Su cuenta no está preparada para usar la tarjeta en línea, por favor contacte con el soporte técnico',
		validation_partner_checking_error: {
			need_update: 'Actualice todos sus dispositivos desde la AppStore (última versión disponible)',
			not_available_origin: 'Este socio no está disponible para L\'Addition Origine',
			not_available_suite: 'Este socio aún no está disponible para L\'Addition Suite'
		},
		check_uuid: 'Verifica la uuid',
		check_existing_acount: 'Continúe su configuración de Pay+ haciendo clic en este enlace. Una vez completado, haga clic en "Siguiente"',
		check_existing_acount_link: 'Configuración',
		ubereats: {
			url_signup: 'https://www.ubereats.com/restaurant/es-ES/signup',
			label_login: 'Acceder a Uber Eats',
			label_signup: '¿Aún no tiene cuenta? Cree su cuenta aquí'
		},
		master_link: {
			title: 'Vinculaciones en sus establecimientos',
			header_company: 'Establecimiento',
			header_id: 'Identificador',
			no_link: 'Sin vinculación',
			configure: 'Configurar',
			config_success: 'La vinculación se ha realizado correctamente',
			config_error: 'No se ha podido realizar la vinculación'
		},
		missing_uuid: 'Ingresa tu uuid de Uber Eats',
		set_uuid: 'Registra la uuid de tienda de Uber Eats',
		documentation: 'Configuración de la carta de l’Addition para %{partner}',
		product_id_at_partner: 'Ingresa los códigos de artículo de L’Addition en la interfaz de Uber Eats.',
		check_if_product_id: 'Verifica que los códigos de artículo de L’Addition estén correctamente especificados para cada artículo de Uber Eats.',
		check_if_product_id_ok: 'Verificar',
		check_product_incomplete: 'Completa los códigos que faltan en la interfaz de Uber Eats y luego presiona el botón "Verificar" nuevamente.',
		check_product_empty: '¿Ha seguido el procedimiento correctamente e ingresado los códigos de artículo de LAddition en la interfaz de Uber Eats?',
		wrong_correspondance_id: 'Algunos artículos sobre Uber Eats no tienen un código de artículo de L\'Addition, complételos.',
		wrong_uuid: 'La verificación de uuid falló, contacte con su administrador de cuenta o con el servicio de asistencia de Uber Eats (dos posibles razones: uuid incorrecto o enlace inactivo en el lado de Uber Eats).',
		uuid_correct: 'Tu uuid de Uber Eats ha sido registrado',
		wrong_option_partner: 'Se produjo un error al recuperar las opciones específicas de la operación del socio.',
		wrong_initialization: 'ha ocurrido un error al activar la cuenta con el socio',
		wrong_desactivation: 'Ha ocurrido un error al desactivación la cuenta con el socio',
		wrong_activation_desactivation: 'Une erreur est survenue lors de l\'activation/désactivation du partenaire',
		need_export_to_activate: 'Debe crear una exportación y exportarla desde su página de socio (rueda dentada) para activar su vinculación',
		ubereats_wrong_initialization: 'Se ha producido un error al autorizar tu cuenta de Uber',
		ubereats_success_initialization: 'Accede a tu cuenta de UberEats OK. Puede continuar con su incorporación',
		ubereats_wrong_provisioning: 'Se ha producido un error durante la selección del establecimiento',
		ubereats_redirection: 'Serás redirigido a la interfaz de inicio de sesión de Uber Eats',
		external_config_redirection: 'Será redirigido a la interfaz de socios',
		ubereats_no_store: 'Falta configuración de stores. Por favor, completa tu configuración en el espacio Uber Eats.',
		ubereats_pos_status: {
			title: 'Recepción de los pedidos en el iPad',
			enabled: 'Activada',
			disabled: 'Desactivada',
			unknow: 'Desconocida',
			label_unknow: 'No hemos podido recuperar el estado de recepción de los pedidos. Actualice la página o contacte con el servicio de integración de L\'Addition.',
			label_disabled: 'Para activar la recepción de pedidos en el iPad, configure y exporte su carta L\'Addition hacia UberEats'
		},
		ubereats_order_validation_switch: 'Validación automática de los pedidos procedentes de UberEats',
		ubereats_order_validation_title: 'Gestión de los pedidos desde la aplicación L\'Addition',
		ubereats_order_manager_info: 'Si la opción está activada, la validación de los pedidos se realizará en su tableta L\'Addition en lugar de en su tableta UberEats',
		ubereats_order_validation_info: 'Si la opción está desactivada, deberá aceptar o rechazar los pedidos manualmente en el iPad.',
		missing_id_list: 'Algunos artículos de Uber Eats no tienen un código de artículo en L\'Addition',
		empty_id_list: 'Ningún artículo de Uber Eats tiene un código de artículo en L\'Addition',
		right_correspondance_id: 'La verificación de los códigos de artículo es correcta',
		ipad_not_live: 'El iPad debe estar conectado, Addition abierto, los módulos Partner activados (Ajustes -> Integraciones Partner -> Módulos Partner activados) en el iPad maestro',
		must_sync_ipad: 'Para completar la configuración de su conector, realice una sincronización (Configuración -> Sincronización manual) y compruebe el estado del botón "Activar módulos de socios" (Configuración -> Integraciones de socios).',
		download_guide: 'Descargar la guía (PDF)',
		integration_guide_pdf: {
			celladdition: 'https://cdn.laddition.com/7/laddition-et-clickandcollect-guide-integration.pdf',
			ubereats: 'https://cdn.laddition.com/7/laddition-y-ubereats-procedimiento-de-integracion.pdf',
			deliverect: 'https://cdn.laddition.com/7/laddition-et-deliverect-guide-integration.pdf',
			ladditionTicket: 'https://cdn.laddition.com/7/laddition-et-deliverect-guide-integration.pdf',
			pms: 'https://cdn.laddition.com/27/integration-laddition-pms.pdf',
			mewsSystems: 'https://cdn.laddition.com/27/integration-laddition-mewssystems.pdf',
			misterBooking: 'https://cdn.laddition.com/27/integration-laddition-misterbooking.pdf',
			tabesto: 'https://cdn.laddition.com/27/integration-laddition-tabesto.pdf',
			dood: 'https://cdn.laddition.com/27/integration-laddition-dood.pdf',
			deliveroo: 'https://laddition.slite.page/p/7OuvQoszliCMCK/L-Addition-and-Deliveroo-Guide-d-integration',
			ladditionTapToPay: 'https://cdn.laddition.com/27/integration-tap-to-pay.pdf',
			thais: 'https://laddition.slite.page/p/-0ekVH6jGzCske/L-Addition-and-Thais-Guide-d-integration'
		},
		tap_to_pay: {
			please_agree_cgv: 'Para continuar, acepte las Condiciones Generales de Venta',
			display_cgv: 'Mostrar las CGV',
			cgv_allready_sign: 'Ya ha firmado las Condiciones Generales de Venta',
			continue_cgv: 'Continuar',
			cgv_pdf: 'https://www.laddition.com/sites/default/files/cgv_laddition_pay.pdf',
			cgv_popup_title: 'Condiciones generales de venta',
			cgv_checkbox: 'Acepto las CGU',
			need_onbaording: 'Rellene el formulario de creación de cuenta Pay+ que ha recibido por correo electrónico.',
			in_validation: 'Su cuenta está en proceso de validación. La validación puede tardar hasta 48 h (en días laborables); el soporte Pay+ se pondrá en contacto con usted si la verificación ha fallado.',
			init_account_label: 'Su cuenta Pay+ aún no está configurada. Introduzca su correo electrónico para recibir el formulario de creación de cuenta:',
			email_sended: 'Acabamos de enviarle un correo electrónico a: %{email}. Siga las instrucciones para configurar su cuenta L\'Addition Pay+. Una vez configurada y verificada su cuenta por nuestros equipos, vuelva aquí para completar su integración ',
			success: '¡Enhorabuena! Ya está listo para utilizar Tap to Pay en iPhone',
			success_popup: '¡Hemos recibido correctamente su solicitud de Tap to Pay en iPhone! Actualmente se encuentra en lista de espera para acceder al servicio; le avisaremos en cuanto pueda realizar sus primeros cobros con Tap to Pay en iPhone.',
			download_app_1: 'Para descargar la aplicación L\'Addition Tap-to-Pay, puede escanear directamente este código QR desde su iPhone',
			download_app_2: 'También puede acceder a la App Store y buscar \'L\'Addition pay+\'',
			documentation: 'Guía de configuración para Tap to Pay en iPhone',
			page_download_app: 'Mientras tanto, puede descargar la aplicación L\'Addition Pay+. Puede escanear directamente este código QR desde su iPhone. También puede acceder a la App Store y buscar "L\'Addition pay+"',
			input_placeholder: 'Su correo electrónico',
			data_empty: 'No se ha podido recuperar el documento a firmar. Si el problema persiste, contacte con el soporte de L\'Addition',
			refresh_data: 'Reintentar',
			sign_error: 'Se ha producido un error al validar la firma.',
			sign_success: 'Documento firmado. Puede continuar su configuración'
		},
		confirm_didnt_read_doc_yolo: {
			export: 'Atención, esta documentación le guiará hasta la exportación final de su carta. ¿Está seguro de que desea continuar sin haber descargado la documentación?',
			tap_to_pay: 'Atención, esta documentación le guiará hasta la configuración completa de Tap to Pay en iPhone. ¿Está seguro de que desea continuar sin haberla descargado?'
		},
		select_store: 'Seleccione su restaurante',
		partial_title: '- Está es la lista de códigos faltantes en Uber Eats:',
		choose_room: 'Elija una sala donde los pedidos del socio se registrarán en l\'Addition.',
		choose_room_cmd_en_ligne: 'Elija una sala en la que se registrarán los pedidos en línea en L’Addition',
		choose_paiement_ticket: 'Elige un medio de pago',
		choose_paiement: 'Elige un medio de pago con el que se registrarán los pedidos del socio en L’Addition.',
		choose_paiement_cmd_en_ligne: 'Elija un medio de pago con el que se registrarán los pedidos online en L’Addition',
		choose_priceCategory: 'Elige una categoría de precios con la que se registrarán los pedidos del socio en L’Addition (OPCIONAL)',
		choose_priceCategory_cmd_en_ligne: 'Elija una categoría de precios con la que se registrarán los pedidos en línea en L’Addition (OPCIONAL)',
		paiement_empty: 'Especifique un medio de pago',
		room_empty: 'Por favor especifique una sala',
		actives_product: 'Productos disponibles',
		suspends_product: 'Productos no disponibles',
		description_menu_selector: 'Seleccione una carta:',
		nb_product: 'Número de producto:',
		type_carte: 'Tipo de carta:',
		primary: 'Permanente',
		secondary: 'Secundario',
		begin: 'Comenzar',
		config: 'Configurar',
		init_liaison: 'Inicializar la configuración del pedido online',
		init_liaison_cel: 'Inicializar la configuración del pedido en línea',
		configuration_guide: 'Continuar con la configuración del pedido en línea',
		must_do_export: 'Para finalizar la reactivación de Uber Eats, debe generar una exportación',
		como_input_pos_external_id: 'Por favor, rellene el Como ID <> LAddition',
		como_input_joining_item: 'Por favor, rellene el punto de unión (Joining Item)',
		como_input_api_key: 'Por favor, introduzca la clave API de Como',
		como_label_link_auth: 'Enlace entre la l\'Addition y Como',
		deliverect_input_location_id: 'Por favor, rellene el locationID (proporcionado por Deliverect)',
		deliverect_input_account_id: 'Por favor, rellene el accountID (proporcionado por Deliverect)',
		deliverect_check_link: 'Verificación',
		unlink_order_partners: 'Actualmente tiene una configuración directa con Deliveroo y/o UberEats. Finalizar la integración los desactivará. ¿Desea continuar? ',
		input_set_customer_id: 'Por favor, introduzca la clave/client id proporcianado por el socio',
		step: {
			step: 'Paso',
			token_copy: 'Copia tu token',
			next_step: 'Siguiente paso',
			previous_step: 'Anterior',
			no_token: '¿Sin clave?',
			finish: 'Terminado'
		},
		set_credential_title: 'Credenciales (proporcionadas por su socio)',
		set_credential_username: 'Identificador',
		set_credential_password: 'Contraseña',
		api_key_verified: 'Clave API verificada',
		deliverect_credientials_verified: 'Account/Location ID verificada',
		misterBooking_credientials_verified: 'Hotel ID verificada',
		eviivo_credentials_verified: 'PropertyShortName verificada',
		dood_customer_id: 'Por favor, introduzca su ID cliente (proporcionado por Dood)',
		tabesto_credientials_verified: 'Identificación del cliente Tabesto verificada',
		mews_credientials_verified: 'Access token verificado',
		zerosix_credientials_verified: 'Token verificado',
		dishop_credientials_verified: 'Identificador de cliente verificado',
		obypay_credientials_verified: 'Identificador Obypay verificado',
		kouver_credientials_verified: 'Conexión con Kouver verificada',
		opentable_credientials_verified: 'Identificador Open Table verificado',
		credientials_verified: 'Credenciales verificadas',
		token_tabesto: 'Por favor, introduzca el token de Tabesto',
		token_koust: 'Por favor, introduzca el token de Koust',
		token_barratio: 'Por favor, introduzca el token de Barratio',
		misterbooking_customer_id: 'Por fabor, introduzca su Hotel ID (proporcionado por MisterBooking)',
		eviivo_customer_id: 'Por fabor, introduzca su PropertyShortName (proporcionado por Eviivo)',
		mews_customer_id: 'Por fabor, introduzca su Access Token (proporcionado por Mews)',
		tickncook_customer_id: 'Por fabor, introduzca su Account ID (proporcionado por TickNCook)',
		zerosix_customer_id: 'Introduzca su Token (proporcionado por Zerosix)',
		opentable_customer_id: 'Introduzca su identificador Open Table (Restaurant ID)',
		dishop_customer_id: 'Introduzca el identificador de cliente proporcionado por Dishop',
		thais_customer_id: 'Introduzca la url proporcionada por Thais',
		generated_customer_id: 'ID de socio generado',
		put_customer_id_at_partner: 'Por favor, introdúzcalo en la interfaz del socio para completar la integración',
		partner_notified: 'Hemos transmitido la información a su socio para que finalice su vinculación',
		onboarding_common_errors: {
			general: 'Se ha producido un error al conectar con el interlocutor. Por favor, inténtalo de nuevo. Póngase en contacto con el servicio técnico si el problema persiste.',
			set_auth_link: 'Se ha producido un error al enlazar con el socio',
			check_customer_id: 'No se ha podido verificar la identificación/la clave del cliente',
			token_generation: 'Se ha producido un error al generar el token de acceso, compruebe su token de usuario.',
			set_entities: 'Se ha producido un error al generar del método de pago/Catégoria de precio/sala en el iPad',
			set_stock_online: 'Se ha producido un error al configurar la cuenta',
			input_validator: 'El formato del texto no es el esperado. ¿Está seguro de que ha rellenado correctamente el campo requerido?',
			set_credentials: 'La url, el identificador o la contraseña son incorrectos. Verifíquelos'
		},
		onboarding_odk_errors: {
			set_laddition_ticket: 'La Adición Ticket no se ha podido inicializar correctamente. Vuelva a intentarlo o póngase en contacto con el servicio técnico si el problema persiste'
		},
		onboarding_como_errors: {
			set_branch_pos_id: 'Se ha producido un error al generar su ID de fidelidad',
			set_api_key: 'Se ha producido un error al comprobar la conexión de la API, compruebe la clave',
			set_liaison_como: 'Se ha producido un error al enlazar con Como',
			set_liaison_webview_loyalty: 'Se ha producido un error al enlazar con el conector de fidelidad la Adición',
			set_api_discount: 'Se ha producido un error al configurar los descuentos en el iPad',
			set_api_payment_type: 'Se ha producido un error al configurar el método de pago en el iPad'
		},
		onboarding_deliveroo_errors: {
			set_brand_id: 'Se ha producido un error, ¿ha introducido correctamente el identificador L\'Addition en su plataforma Deliveroo?'
		},
		onboarding_deliverect_errors: {
			set_location_id: 'Se ha producido un error al registrar el location ID',
			set_account_id: 'Se ha producido un error al registrar el account ID',
			check_acount_location: 'Se ha producido un error al comprobar su location ID / Account ID, por favor, vuelva a introducirla.',
			set_variable_config_channel: 'Se ha producido un error al comprobar su identificación de cuenta/ubicación, por favor, vuelva a introducirla.',
			set_liaison_deliverect: 'Se ha producido un error al enlazar con Deliverect',
			mandatory_field: 'Este campo es obligatorio',
			set_table_and_paiement: 'Ocurrió un error al asignar su método de pago y habitación predeterminada',
			same_account_location_id: 'El location_id y el account_id no pueden ser idénticos. Por favor, vuelva a escribirlos'
		},
		onboarding_ladditionticket_errors: {
			set_customer_id: 'Une erreur est survenu lors de l\'enregistrement de l\'identifiant client',
			call_laddition_ticket: 'Une erreur est survenue pendant la connexion avec le partenaire',
			set_api_variables: 'Une erreur est survenu lors de l\'initialisation des variables de fonctionement'
		},
		onboarding_tabesto_errors: {
			set_table_payment_and_price_category: 'Se ha producido un error al asignar la forma de pago / habitación / categoría de precio por defecto',
			set_token_tabesto: 'La clave de configuración Tabesto no ha sido reconocida'
		},
		onboarding_misterBooking_errors: {
			check_hotel_id: 'Se ha producido un error al comprobar su Hotel ID, por favor, vuelva a introducirla.'
		},
		onboarding_mewsSystems_errors: {
			check_customer_id: 'Se ha producido un error al verificar su Access Token. Vuelva a introducirlo.',
			no_selection: 'Debe seleccionar un elemento de la lista'
		},
		onboarding_eviivo_errors: {
			check_customer_id: 'Se ha producido un error al comprobar su PropertyShortName por favor, vuelva a introducirla.'
		},
		onboarding_zerosix_errors: {
			check_token: 'Token Zerosix no reconocido.'
		},
		onboarding_dishop_errors: {
			check_token: 'Identificador de cliente Dishop no reconocido.'
		},
		onboarding_kouver_errors: {
			partner_checking: 'No se pudo verificar la conexión con Kouver. Compruebe su configuración en Kouver.',
		},
		onboarding_opentable_errors: {
			check_customer_id: 'Identificador Open Table no reconocido.',
		},
		onboarding_obypay_errors: {
			check_token: 'Identificador de cliente Obypay no reconocido.'
		},
		onboarding_rushour_errors: {
			set_restaurant_id: 'Error: su configuración Rushour no parece estar completa'
		},
		onboarding_booking_error: {
			failed_synchro: 'La sincronización de las reservas del socio ha fallado'
		},
		resalys: {
			wrong_credentials: 'Uno o varios campos son incorrectos, verifíquelos en su interfaz Resalys',
			wrong_entities: 'Las salas, los tipos de IVA o los métodos de pago no están correctamente configurados en su interfaz Resalys',
			copy_token: 'Haga clic para copiar el código a introducir en la interfaz Resalys: ',
			fill_form: 'Introduzca los siguientes campos (a obtener en su cuenta Resalys):',
			click_to_configure: 'Haga clic aquí para configurar su vinculación',
			modal_title: 'Configuración del socio'
		},
		onboarding_booking_success: {
			synchro: 'La sincronización de las reservas del socio se ha realizado correctamente'
		},
		mandatory_field: 'Este campo es obligatorio',
		link_partner_customer_allready_exist: 'Ya existe un enlace con este locationID y el socio. Póngase en contacto con el servicio de atención al cliente del socio.',
		link_partner_check_error: 'Se ha producido un error, inténtelo de nuevo',
		onboarding_success_config: {
			default: 'En cualquier momento puede configurar sus opciones desde la página de configuración del conector %{partner_name}',
			title: 'Conector activado',
			pms: 'Para finalizar la integración, haga coincidir los elementos de su caja con los creados en %{partner_name}',
			export: 'Para finalizar la integración, configure su menú para poder exportarlo hacia %{partner_name}'
		},
		onboarding_success: 'El enlace con su pareja se ha iniciado correctamente',
		popupExternalId: 'Identificador que se transmitirá al interlocutor',
		authenticationToken: 'Clave de autenticación',
		popupInfo: {
			external_id: 'Identificador del socio',
			token: 'Clave de autenticación',
			account_id: 'Account id',
			location_id: 'Location id',
			token_barratio: 'Clave Barratio',
			koust_token: 'Clave Koust',
			kitchen_id: 'Kitchen id'
		},
		update_nuc_ignored: 'Licencia única detectada - Paso 2: Actualizar servidor Adición ignorada.',
		prefix: {
			1055: 'Dionysols',
			guest: 'Invitado online',
			netresto: 'Mycawan',
			fourch: 'El Tenedor',
			zen: 'Zenchef',
			bts: 'BtsVendee',
			shine: 'Shine',
			ciss: 'Ciss',
			pmt: 'Pay My Table',
			beefhouse: 'Beef House',
			mediation: 'Mediation',
			bfast: 'Bfast',
			celladdition: 'El pedido online',
			tgpl: 'The Good Place',
			gstock: 'GStock',
			deliveroo: 'Deliveroo',
			easilys: 'Easilys',
			ubereats: 'Uber Eats',
			snapshift: 'Combo',
			deliverect: 'Deliverect',
			ladditionTicket: 'Ticket / Paiement à table',
			dood: 'DOOD',
			tabesto: 'Tabesto',
			barratio: 'Barratio',
			koust: 'Koust',
			mewsSystem: 'Mews System',
			misterBooking: 'Mister Booking',
			bardistrib: 'Bar Distribution',
			eviivo: 'Eviivo',
			yokitup: 'Yokitup',
			ladditionTapToPay: 'Tap to Pay en iPhone',
			deepsight: 'Inpulse',
			chaponfin2: 'Somm\'IT',
			theometrics: 'Food Report',
			chift: 'Chift',
			stansoft: 'GoStan',
			kolia: 'Kolia',
			covermanager: 'CoverManager',
			lyoneats: 'LyonEats',
			belorder: 'Belorder',
			fullsoon: 'Fullsoon',
			littlebill: 'LittleBill',
			kouver: 'Kouver',
			opentable: 'Open Table',
			Billiv: 'Billiv',
			como: 'Como',
			pennylane: 'Pennylane',
			otter: 'Otter',
			mewsSystems: 'Mews System',
			skello: 'Skello',
			pongo: 'Pongo',
			tickncook: 'TicknCook',
			sunday: 'Sunday',
			obypay: 'Obypay',
			zerosix: 'Zerosix',
			dishop: 'Dishop',
			melba: 'Melba',
			rushour: 'Rushour',
			Dvore: 'Dvore',
			calive: 'CA Live',
			thais: 'Thais PMS',
			resalys: 'Resalys',
			billiv: 'Billiv',
			odk: 'Odk',
			ladditionMenu: "l'Addition Menu",
			ladditionPayPlus: "l'Addition Pay+",
			ouilink: "l'Addition Compras",
			laddition: "l'Addition Reservas",
		},
		option: {
			title: 'Configuración del iPad',
			event: 'Actividad',
			empty: 'No hay opciones en la lista',
			advanced_settings: 'Gestión avanzada',
			simple_settings: 'Gestión sencilla',
			need_update: 'Es necesario actualizar la aplicación',
			option_order_paid: 'Pedido pagado',
			option_order_unpaid: 'Pedido no pagado',
			category: {
				ticket: 'Recibido',
				manufacturing: 'Orden de producción',
				notification: 'Notificación',
				order: 'Pedido',
				price: 'Precio',
				other: 'Otros',
				print_option: 'Opciones de impresión'
			},
			name: {
				autoOrderClosed: 'Cierre del pedido a la recepción',
				autoPrintManufacturing: 'Impresión automática de la orden de elaboración',
				autoPrintManufacturingPaid: 'Impresión automática de la orden de elaboración (con pagos)',
				autoPrintManufacturingUnPaid: 'Impresión automática de la orden de elaboración (sin pago)',
				table_autoPrintManufacturing: '(Mesa) Impression automatique du bon de fabrication',
				table_autoPrintManufacturingPaid: '(Mesa) Impresión automática de la orden de elaboración (con pagos)',
				table_autoPrintManufacturingUnPaid: '(Mesa) Impresión automática de la orden de elaboración (sin pago)',
				autoPrintReceipt: 'Impresión automática del ticket',
				autoPrintReceiptPaid: 'Impresión automática del ticket (con pagos)',
				autoPrintReceiptUnPaid: 'Impresión automática del ticket (sin pago)',
				table_autoPrintReceipt: '(Mesa) Impresión automática del ticket',
				table_autoPrintReceiptPaid: '(Mesa) Impresión automática del ticket (con pagos)',
				table_autoPrintReceiptUnPaid: '(Mesa) Impresión automática del ticket (sin pago)',
				checkStock: 'Comprobación del stock antes confirmar un pedido',
				showNotification: 'Notificación visual en la recepción',
				showNotificationPaid: 'Notificación visual en la recepción (con pagos)',
				showNotificationUnPaid: 'Notificación visual en la recepción (sin pago)',
				table_showNotification: '(Mesa) Notificación visual en la recepción',
				table_showNotificationPaid: '(Mesa) Notificación visual en la recepción (con pagos)',
				table_showNotificationUnPaid: '(Mesa) Notificación visual en la recepción (sin pago)',
				playNotificationSound: 'Notificación sonora en la recepción\n',
				playNotificationSoundPaid: 'Notificación sonora en la recepción (con pagos)',
				playNotificationSoundUnPaid: 'Notificación sonora en la recepción (sin pago)',
				table_playNotificationSound: '(Mesa) Notificación sonora en la recepción',
				table_playNotificationSoundPaid: '(Mesa) Notificación sonora en la recepción (con pagos)',
				table_playNotificationSoundUnPaid: '(Mesa) Notificación sonora en la recepción (sin pago)',
				printTicketComment: 'Imprimir el comentario del cliente en el ticket',
				realPrice: 'Integración de la facturación (precios reales de los productos)',
				manualCancel: 'Cancelación manual de pedidos',
				showPaymentStatus: 'Mostrar el icono de estado del método de pago',
				autoOrderClosedPaymentLine: 'Cerrar automáticamente la orden si está cerrada',
				autoPrintReceiptPaymentLine: 'Impresión automática del recibo si el pedido se agota',
				showNotificationPaymentLine: 'Notificación si el pedido se ha agotado',
				showNotificationPaymentLine_swift: 'Notificación al recibir',
				table_autoOrderFusion: 'Transferencia a las mesas abiertas',
				table_autoOrderFusionPaid: 'Transferencia a las mesas abiertas (con pago) ',
				table_autoOrderFusionUnPaid: 'Transferencia a las mesas abiertas (sin pago)',
				table_autoForceDirect: 'Agregar todos los productos en vivo',
				checkExactTableName: 'Inspeccione el nombre exacto de la tabla para encontrar su identificador',
				table_checkExactTableName: 'Inspeccione el nombre exacto de la tabla para encontrar su identificador',
				autoPrintPicking: 'Impresión del ticket de montaje',
				autoPrintPickingPaid: 'Impresión del albarán de montaje (pedidos pagados)',
				autoPrintPickingUnPaid: 'Impresión del vale de preparación (pedidos no pagados)',
				replaceProductNames: 'Utilizar los nombres de productos definidos en la caja en los tickets de caja y los vales de fabricación',
				preventPaymentModification: 'Impedir la modificación del pago',
				autoPrintTotal: 'Impresión del importe restante a pagar'
			}
		},
		configuration_module: {
			title_cc: 'Configuración del módulo',
			title: 'Configuración de la integración',
			guide: 'Guía (PDF)',
			link_admin_cc: 'Ir a la interfaz de configuración'
		},
		cateogies_active: 'Categorías activadas',
		categorie_inactive: 'Categorías desactivadas',
		products_selector: {
			title: 'Importar productos',
			select_menu: 'Seleccionar un menú',
			import_products: 'Importar productos',
			no_selection: 'Ningún elemento seleccionado',
			select_all: 'Seleccionar todo',
			deselect_all: 'Deseleccionar todo',
			section_list: {
				title: 'Categorías',
				none: 'Ninguna otra sección',
				all: 'Todos los productos',
				no_category: 'Sin categoría',
				menus: 'Menús'
			},
			selected_list: {
				title: 'Selección',
				no_selection: 'Ningún producto seleccionado',
				x_items_selected: '+ %{number} elemento(s) seleccionado(s)',
				unknow_menu: 'Menú'
			},
			selectionable_list: {
				search: 'Buscar un producto',
				title: 'Productos',
				no_selection: 'Ningún producto en esta sección',
				no_product: 'Ningún producto'
			},
			menu_select_reset_select: '¿Está seguro de querer cambiar su menú? Su selección actual se reiniciará'
		},
		productForm: {
			productSelected: 'Producto seleccionado',
			vat: 'IVA',
			vat_undefined: 'No definida',
			confirm_delete_image: '¿Está seguro de querer eliminar esta imagen?',
			name: 'Nombre',
			visible: 'Visible',
			notVisible: 'Invisible',
			description: 'Descripción',
			price: 'Precio',
			active: 'Activado',
			import: 'Importar',
			image: 'Añadir una imagen',
			supplement: 'Gestionar los suplementos',
			supplement_button: 'Gestionar los suplementos e información adicional',
			empty: 'No tiene ningún suplemento configurado',
			back: 'Volver',
			reset_button: 'Restablecer',
			reset_button_menu: 'Restablecer el menú',
			category_supplement_disabled: 'Ve a "Editar extras" para cambiar el nombre, el precio y el tipo de extras. Las categorías y los suplementos en gris están desactivados por defecto.',
			take_away: 'Para llevar',
			locally: 'Para tomar en el local',
			tooltip_visible: 'Visibilidad: el producto seguirá siendo visible en el mapa pero estará desactivado',
			tooltip_visible_disabled: 'La visibilidad del producto se gestiona directamente desde el iPad',
			tooltip_product_in_menu_category_supplement: 'Gestionar los suplementos',
			alert_supp_missing: 'Atención, parece que tiene categorías de suplementos sin ningún suplemento en su interior. Elimine esta categoría de suplementos o asóciele suplementos',
			image_deliveroo: 'Formatos aceptados: JPEG, PNG. Al menos 1920x1080 píxeles, formato 16:9.'
		},
		supplements: {
			manage: 'Modificar los suplementos',
			name: 'Nombre',
			type: 'Tipo',
			price: 'Precio',
			image: 'Imagen',
			supplements: 'suplementos',
			reset: 'Poner a 0',
			reset_confirm: '¿Está seguro de querer restaurar los valores por defecto de esta categoría de suplementos? Los nombres, tipos y precios de los suplementos volverán a su valor original.',
			types: {
				1: 'Una opción',
				2: 'Varias opciones',
				3: 'Varias opciones en cantidad'
			},
			remove_supplement_extra_confirm: 'Esto restablecerá las categorías de suplementos por defecto para este producto. ¿Está seguro de que quiere realizar esta acción? ',
			from: 'De',
			to: 'a',
			maximum_choices: 'Máximo número de opciones',
			required: 'Obligatoria',
			empty: 'No hay categoría de suplementos para esta carta',
			empty_menu: 'No se ha configurado ninguna categoría de suplementos',
			no_select_menu: '- Seleccionar -',
			description_1: 'Puede modificar los suplementos de su carta para adaptarlos al pedido en línea (nombre, tipo, precio). Seleccionar una carta para empezar.',
			alert_extra_prefix: 'Los cambios realizados para este socio no afectan a los demás socios'
		},
		export: {
			confirm_delete: '¿Está seguro de que quiere eliminar esta exportación ?',
			confirm_export: '¿Está seguro de que quiere continuar?',
			active: 'Activo',
			see_more: 'Elige otra exportación',
			list: 'Mis exportaciones',
			unamed: 'Exportación sin título',
			loading: 'Cargando los datos de los productos...',
			generate_success: 'Exportación generada con éxito',
			export_fail_empty: 'No puede exportar un menú vacío',
			generate_fail: 'Se ha producido un error',
			generate_fail_generation: 'Se ha producido un error al generar la exportación',
			generate_fail_notif: 'Su exportación ha sido generada pero su socio no ha podido ser notificado',
			generate_fail_notif_partner_error: {
				too_many_requests: 'Limitación de 1 exportación/min por el socio',
				price_too_high: 'Uno o varios productos superan el límite de precio de UberEats (%{price})',
				menu_not_enable: 'La importación de menú está desactivada en su cuenta Tabesto. Contacte con el servicio de atención al cliente de Tabesto para activarla.',
				tabesto_sync_in_progress: 'Parece que su exportación aún está en proceso de sincronización en Tabesto. Inténtelo de nuevo en unos minutos.',
				brand_not_found: '¿Ha finalizado correctamente su configuración de Deliveroo?'
			},
			incompleted_product: 'Algunos productos no están completos, por lo que no pueden ser integrados:',
			new_export: 'Nueva exportación',
			new_export_from_another_export: 'Nueva exportación de...',
			copy_of: 'Copia de',
			select_export: '-- Seleccionar una exportación --',
			select_export_empty: 'Por favor, seleccione una exportación de la lista desplegable',
			export_error: 'Ha ocurrido un error',
			no_modification: 'No ha habido ninguna modificación desde la última exportación, ¿está seguro de que quiere reexportar?',
			menu_configuration: 'Configuración del menu',
			activate_link_ubereats: '¿Quieres habilitar Uber Eats para recibir pedidos en L’Addition?',
			copy_cat_supp_extra: '¿Desea también copiar las modificaciones de las categorías de suplementos y suplementos realizadas en %{source} a %{target}?',
			date_last_deployment: 'Fecha de la última implementación',
			date_last_deployment_to: 'a las',
			helper_no_export: 'Pour que vos clients puissent passer des commandes via ce partenaire, vous devez préparer votre export de carte. Cliquez sur "Nouvel export" pour commencer. ',
			helper_not_exported: 'Vous pouvez a tout moment modifier les sections et produits de votre export. N\'oubliez pas de cliquer sur le bouton "Déployer" pour envoyer votre export de carte au partenaire.',
			deliveroo_export_info: 'Desplegar tu tarjeta puede desactivar las ofertas configuradas en tu centro Deliveroo. Recuerda comprobar tus ofertas en tu centro Deliveroo y reactivarlas desde la pestaña Marketer después de desplegar tu tarjeta.',
			deliveroo_info_1_min: 'Tenga en cuenta que la API de Deliveroo está limitada a 1 exportación/minuto.',
			tabesto_info_export: 'Tenga en cuenta que Tabesto sugiere limitar a una exportación cada 15 minutos.',
			sync_button: 'Sync',
			sync_alert: 'Esta funcionalidad tiene como objetivo actualizar los productos que han cambiado en el iPad/Carta web pero que no se han sincronizado correctamente en sus exportaciones. Al hacer clic en \'Continuar\', fuerza una resincronización de los productos - <b>Atención</b>, esta acción debe realizarse como solución de emergencia; si necesita utilizarla de forma regular, seguramente algo no funcione bien. Debería comentarlo con support@laddition.com',
			sync_success: 'Los productos se han sincronizado. Exportaciones afectadas: %{nb}',
			sync_error: 'Se ha producido un error durante la sincronización de los datos. Inténtelo de nuevo más tarde',
			copy_error: 'Se ha producido un error y algunas exportaciones no se han copiado: %{children}. Si el problema persiste, contacte con el soporte técnico',
			generate_error: 'Se ha producido un error y algunas exportaciones no se han exportado: %{children}. Si el problema persiste, contacte con el soporte técnico',
			copy_success: 'Exportación(es) copiada(s) correctamente',
			master: {
				copy_on: 'Copiando la exportación en %{child}...',
				generate_on: 'Desplegando en %{child}...',
				select_children_generate: 'Desplegar la exportación en el socio para los siguientes establecimientos:',
				select_children_copy: 'Copiar la exportación en los siguientes establecimientos:'
			}
		},
		general_options: {
			button: 'Options générales',
			title: 'Réglages partenaire généraux',
			ipad_changes: {
				title: 'Mise à jour des produits depuis l\'iPad',
				description: 'Vous pouvez configurer les regles de mise à jour de vos export lorsque des produits et suppléments sont synchronisés depuis l\'iPad. Si ces options sont cochés. Chaque modification remontée mettra à jour votre export chez vos partenaires de commandes en ligne.',
				label_product_name: 'Mise à jour nom',
				label_product_price: 'Mise à jour prix'
			}
		},
		brandChannel: {
			error_empty: 'Configuración imposible, no se encontró ningún canal. Por favor recarga la página',
			title: 'Marcas / Canales',
			title_brand: 'Marcas',
			title_channel: 'Canales',
			select_placeholder: 'Selection ...',
			brand_channels: 'Canales específicos',
			add_channel: 'Agregar canal específico',
			channel_name: 'Apellido',
			channel_floor: 'Salón',
			channel_payment_type: 'Modo de pago',
			channel_price_category: 'Categoría de precio',
			delete_confirmation: '¿Está seguro de que desea eliminar este elemento?',
			mandatory_field: 'Este campo es obligatorio',
			brand_tooltip: 'Una marca o cocina oscura corresponde a la asociación habitación / pago / categoría de precio necesaria para la inyección de ventas en el sistema de caja para un canal determinado (para diferenciar los artículos que se ofrecen en la tienda y los que solo están disponibles en línea)',
			channel_tooltip: 'Un canal o plataforma corresponde a la asociación habitación/pago/categoría de precio necesaria para inyectar ventas en el sistema de pago (para diferenciar UberEats, Deliveroo, etc.)',
			no_channel_set: 'Ningún Channel configurado'
		},
		ladditionTicket: {
			activate_payplus: 'Activar el enlace L\'Addition Pay+',
			activate_payplus_popup: '¿Desea activar los pagos en mesa?',
			payplus_activated: 'El enlace L\'Addition Pay+ está activo',
			payplus_activation_fail: 'La activation del enlace L\'Addition Pay+ no sé passa bien',
			payplus_activation_fail_no_account: 'No tiene cuenta Pay+. Contacte con el soporte',
			print_title: '¡Equipe sus mesas con expositores!',
			print_p1: 'Compuestos por dos elementos separables, una base de madera y una placa de Forex.',
			print_p2: 'Este expositor permitirá escanear el código QR asociado a la mesa y pagar parcial o totalmente la cuenta.',
			print_p3: 'Dimensiones: 22x15x5',
			print_btn_order: 'Realizar pedido',
			print_btn_config: 'Configuro mis códigos QR',
			tips: {
				save_success: 'Las propinas se han registrado correctamente',
				save_fail: 'Se ha producido un error al registrar las propinas',
				title: 'Gestión de las propinas',
				switch: 'Activar las propinas',
				empty: 'Ninguna propina configurada',
				add: '+ Añadir una propina (máximo 3)'
			},
			optionPrintQR: {
				label: 'Imprimir el código QR en el ticket'
			}
		},
		misterBooking_paymentType: {
			CB: 'Tarjeta de débito',
			ESP: 'Efectivo',
			CHQ: 'Consulte',
			TICKET_RESTAURANT: 'Vales de comida',
			TICKET_RESTAURANT_DEMAT: 'Ticket restaurante desmaterializado',
			AMEX: 'Amex',
			VIR: 'Transferencia',
			PERTE: 'Pérdida',
			CHQVAC: 'Bonos de vacaciones',
			BON_CADEAU: 'Cheque regalo',
			CHL: 'Bonos logis'
		},
		externalData: {
			load_error: 'No se han podido cargar los datos. Por favor, inténtelo de nuevo',
			info: 'Para que la configuración sea óptima, debe vincular %{entity} de L\'Addition a un equivalente de su socio. De este modo, los pedidos realizados se registrarán correctamente con su socio.',
			info_entity: {
				paymentType: 'todos los métodos de pago',
				floor: 'todas las salas',
				floorAll: 'todas las salas',
				priceCategory: 'todas las categorías de precios',
				productType: 'todos los typo de productos',
				productId: 'los productos que lo quieres'
			},
			refreshData: 'Actualizar los datos',
			settingsProductTypes: 'Vinculación de tipos de productos',
			settingsProduct: 'Vinculación de productos (opcional)'
		},
		mewsSystems: {
			serviceInputDescription: 'Introduzca el servicio de Mews que se vinculará al sistema L\'Addition',
			serviceInputLabel: 'Servicio',
			outletInputDescription: 'Introduzca el punto de venta de Mews que se vinculará al sistema L\'Addition',
			outletInputLabel: 'Salida',
			paymentInputDescription: 'Introduzca el método de pago de Mews que se vinculará por defecto al sistema de L\'Addition',
			paymentInputLabel: 'Forma de pago',
			tipsInputLabel: 'Propinas',
			outletEmpty: 'Lista de outlets Mews vacía',
			servicesEmpty: 'Lista de servicios adicionales Mews vacía',
			paymentEmpty: 'Lista de categorías contables/de pago Mews vacía',
			refreshData: 'Refrescar datos',
			documentationDescription: 'Parece que algunos de los datos de tus sistemas Mews están vacíos. ¿Los llenaste bien? Si es así, haga clic en el botón "Actualizar datos de Mews". Si no, gracias por consultar la documentación de los sistemas Mews a continuación',
			documentationCreateService: 'Crear un servicio',
			documentationService: 'Comprender los servicios en torno al POS',
			documentationAccounting: 'Contabilidad',
			settingsDefault: 'Configuración salida / servicio / y pago por defecto',
			settingsPayments: 'Vinculación de los métodos de pago',
			settingsProductTypes: 'Vincular tipos de producto',
			settingsProduct: 'Vinculación de productos (opcional)',
			labelLinkManageServices: 'Crear o eliminar servicios adicionales',
			labelUnderstandServices: 'Entender los servicios',
			labelLinkAccountingCategories: 'Crear una categoría contable',
			labelLinkOutlets: 'Gestiona tus Outlets',
			labelLinkIntegrationPOS: 'Integration del POS a Mews Operation',
			settingsFloorOutlet: 'Vincular de los  salas(opcional)',
			documentation: {
				manageServices: 'https://help.mews.com/s/article/create-or-delete-an-additional-service?language=es',
				understandServices: 'https://help.mews.com/s/article/understanding-services?language=es',
				manageAccountingCategories: 'https://help.mews.com/s/article/create-an-accounting-category?language=es',
				manageOutlets: 'https://help.mews.com/s/article/set-up-outlets?language=es',
				integrationPOS: 'https://help.mews.com/s/article/point-of-sale-integrations-for-mews-operations?language=es'
			},
			mewsConfigNotComplete: 'La configuracion no esta terminado al Mews Operations.'
		},
		misterBooking: {
			cancelNoteTitle: 'Cancelar una entrada',
			cancelNoteDescription: 'Esta función permite cancelar un billete por su pmsId en MisterBooking. Tenga en cuenta que la facturación de L\'Addition no se modificará / rectificará',
			cancelNoteButton: 'Cancelar',
			cancelNoteSuccess: 'El ticket N°%{noteId} ha sido cancelado en MisterBooking',
			cancelNoteFail: 'Se ha producido un error al cancelar el billete N°%{noteId} en MisterBooking y/o este identificador no existe'
		},
		tickncook: {
			select_kitchen: 'Seleccione su cocina',
			kitchen: 'Cocina'
		},
		booking: {
			partner_synchro: 'Sincronizar las reservas'
		},
		pongo: {
			enable_webview: 'Activar la interfaz de fidelización Pongo',
			webview_help: 'Al activar esta opción, utilizará la interfaz de su socio para la gestión de la fidelización de sus clientes. Una vez marcada esta opción, realice una sincronización manual y reinicie su aplicación L\'Addition iPad para que se apliquen los cambios.'
		},
		id_to_patner: 'Proporcione este identificador a su socio'
	},
	exports: {
		deploy_date: 'Fecha de implementación',
		exportModal: {
			export: 'Exportar',
			to_export: 'Exportar',
			to_deploy: 'Implementar',
			export_name_empty_error: 'Por favor, introduzca el nombre de exportación',
			deploy_single: 'Este establecimiento',
			deploy_master: 'Establecimientos hijos'
		},
		sectionList: {
			my_sections: 'Secciones',
			my_products: 'Mis productos',
			details: 'Detalles',
			select_section: 'Seleccionar una sección',
			recap: 'Resumen',
			add_section: 'Añadir una sección',
			new_section: 'Sección sin título',
			description_placeholder: 'Descripción ... '
		},
		recapExport: {
			empty: '(vacío)',
			incompleted_product: 'Atención, los productos con notificación están incompletos.'
		},
		formSection: {
			section_name: 'Nombre de la sección',
			section_description: 'Descripción (facultatif)',
			section_delete: 'Eliminar la sección',
			section_name_empty_error: 'Por favor, introduzca un nombre de sección',
			empty_product: 'Ningún producto en esta sección',
			confirm_delete_product: '¿Está seguro de querer eliminar el producto de esta sección ?',
			confirm_delete_section: '¿Está seguro de que quiere eliminar esta sección ?',
			removed_product: '[Producto eliminado]'
		},
		formProduct: {
			product_delete: 'Eliminar este producto',
			reset_extra: 'Esto restablecerá el producto por defecto. ¿Está seguro de que desea ejecutar esta acción?'
		},
		menuLevel: {
			checkbox_isHub: 'Pivot',
			hint_isHub: 'Si se selecciona esta opción, la aplicación enviará tantos menús como productos haya en el nivel de menú seleccionado',
			reset_extra: 'Esto restablecerá el menú por defecto. ¿Está seguro de que desea ejecutar esta acción?',
			placeholder: {
				description: 'Añada una descripción'
			}
		},
		field_cant_be_empty: 'Este campo no puede estar vacío',
		banner: {
			title: 'Photo cover',
			description: 'Debe mostrar su marca y animar a los clientes a visitar la página de su restaurante. Formatos aceptados: JPEG, PNG. Al menos 1920x1080 píxeles, formato 16:9.',
			confirm_delete: '¿Está seguro de que desea eliminar la photo cover de este socio?',
			add: 'Añadir photo'
		}
	},
	request: {
		fail: 'Error en la solicitud de %{endPoint}'
	},
	breadcrumb: {
		partners: 'Socios',
		home: 'Inicio',
		info: 'Información general'
	},
	variable: {
		title_modal: 'Aviso',
		description_modal: 'Los cambios en su menú han afectado a una o más de sus exportaciones. Por lo tanto, las exportaciones afectadas se han modificado en consecuencia y se han vuelto a desplegar automáticamente.\n',
		got_it: 'Vale',
		impacted_export: 'Exportación(es) afectada(s)',
		generate_new_export: 'Generar una nueva exportación',
		multisession: {
			label: 'Cuidado, parece que ya hay una sesión abierta en este servicio. ¿Está seguro de querer acceder ? Esto cerrará cualquier otra sesión activa',
			button: 'Activar mi sesión'
		}
	},
	errorBoundary: {
		title: 'Se ha producido un error',
		keepError: 'Si el problema persiste, póngase en contacto con nuestro soporte técnico.',
		reload: 'Recargar',
		errorCode: 'Código de error',
		interjections: ['¡Por mis barbas!', '¡Caramba!', '¡Rayos y centellas!', '¡Córcholis!', '¡Recórcholis!', '¡Cáspita!'],
		configError: 'Su cuenta no ha sido configurada correctamente, por favor contacte con el soporte técnico.'
	},
	firstLogin: {
		fail: 'Se ha producido un error durante el inicio de su cuenta',
		init: 'Iniciar su cuenta',
		errors: {
			SET_INFO_FAIL: 'Su cuenta ha sido iniciada pero su información no ha podido ser recuperada, recuerde completarla en la sección "Información".'
		}
	},
	master: {
		connectedAs: 'Conectado como',
		masterAccount: 'cuenta maestra',
		login_error: 'Se ha producido un error durante la conexión a la cuenta, volviendo a la cuenta Master...'
	}
};
